import React from 'react';
import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import Tooltip from '@mui/material/Tooltip';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import useStyles from '../../styles/alertForm';
import { UIOptions } from '../../services/api';

interface UIOptionsProps {
  uiOptions: UIOptions | null | undefined;
  onChange: (UIOptions: UIOptions) => void;
  allowEditing: boolean;
}

function UIOptionsFormSection({ uiOptions, onChange, allowEditing }: UIOptionsProps) {
  const { classes } = useStyles();
  const theme = useTheme();
  const userNote = uiOptions?.userNote ?? '';

  return (
    <Box className={classes.formContainer}>
      <InputLabel sx={{ mb: 2 }}>Select UI Options</InputLabel>
      <Grid container spacing={1.5}>
        <Grid size={{ sm: 12, xs: 12 }}>
          <TextField
            fullWidth
            size="small"
            label="User Note (optional)"
            placeholder=""
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            value={userNote}
            disabled={!allowEditing}
            onChange={(e) => {
              const newValue = e.target.value;
              onChange({
                ...(uiOptions as UIOptions),
                userNote: newValue ?? '',
              });
            }}
            variant="outlined"
            sx={{
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.primary.contrastText,
              },
            }}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="Note to be included in alert" placement="top" arrow>
                      <HelpOutlineIcon
                        fontSize="small"
                        sx={{ cursor: 'pointer' }}
                        color="secondary"
                      />
                    </Tooltip>
                  </InputAdornment>
                ),
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default UIOptionsFormSection;
